const auth = (status) => {
	if (status === 'UNAUTHORIZED') {
		localStorage.setItem('admin', '');
		window.location.replace('/');
		// alert('Session timeout, please login again.');
		return false;
	} else {
		return true;
	}
};

export default auth;
